module.exports = __webpack_public_path__ + "img/ic_close.6f3a3a7c.svg";